import React from "react";

function Header() {
  return <header className=" mb-5 sm:mb-10">
    <p>Katrín Hersisdóttir</p>
  </header>;
}
export default Header;